import React from 'react';
import styled from 'styled-components';
import {useOutlet, getOutlet} from 'reconnect.js';
import TdaCategoryTree from '../../Components/TdaCategoryTree';
import * as AppActions from '../../AppActions';
import * as User from 'rev.sdk.js/Actions/User';
import * as NavUtil from '../../Utils/NavUtil';

// const ProfileCategory = {
//   categories: [
//     {
//       name: '會籍登記資料',
//       display: '會籍登記資料',
//       url: '/profile/',
//     },
//     {
//       name: '常年會費繳納紀錄',
//       display: '常年會費繳納紀錄',
//       url: '/profile/member-fee/',
//     },
//     {
//       name: '活動報名紀錄',
//       display: '活動報名紀錄',
//       url: '/profile/evt-reg/',
//     },
//     {
//       name: '進修時數紀錄',
//       display: '進修時數紀錄',
//       url: '/profile/study-hour/',
//     },
//   ],
// };

export default function ProfileLayout(props) {
  const [user] = useOutlet('user');
  const profileCats = React.useMemo(() => {
    return {
      categories: [
        {
          name: '基本資料',
          display: '基本資料',
          url: '/doctor/member/MBData',
        },
        ...(user
          ? [
              {
                name: '密碼修改',
                display: '密碼修改',
                onClick: () => {
                  getOutlet('reset-password-modal').update(true);
                },
              },
            ]
          : []),

        {
          name: '會員福利',
          display: '會員福利',
          url: '/doctor/member',
        },
        {
          name: '北市牙醫雜誌',
          display: '北市牙醫雜誌',
          url: '/doctor/member/journal',
        },
        {
          name: '繼續教育積分查詢',
          display: '繼續教育積分查詢',
          url: '/doctor/member/MBScore',
        },
        {
          name: '應繳費用查詢',
          display: '應繳費用查詢',
          url: '/doctor/member/MBFee',
        },
        {
          name: '繳費記錄查詢',
          display: '繳費記錄查詢',
          url: '/doctor/member/MBFeeRecord',
        },
        {
          name: '會員繳費處',
          display: '會員繳費處',
          url: '/doctor/member/MBFirstBank',
        },

        ...(user
          ? [
              {
                name: '登出',
                display: '登出',
                onClick: async () => {
                  AppActions.setLoading(true);
                  User.logout();
                  await AppActions.delay(500);
                  AppActions.setLoading(false);
                  AppActions.navigate('/doctor');
                },
              },
            ]
          : []),
      ],
    };
  }, [user]);

  return (
    <Wrapper>
      <main className="tda-layout">
        <div className="nav">
          <TdaCategoryTree
            title="會員專區"
            root={profileCats}
            location={props.location}
            checkSelected={({url}) =>
              NavUtil.sliceTailSlash(url) ===
              NavUtil.sliceTailSlash(props.location.pathname)
            }
          />
        </div>
        {['/doctor/member/MBFeeRecord', '/doctor/member/MBFee'].includes(
          props.location.pathname,
        ) ? (
          <h3>未開放功能</h3>
        ) : user ? (
          <div className="content">{props.children}</div>
        ) : (
          <div className="content">
            <h3 style={{paddingTop: 80, textAlign: 'center'}}>請先登入</h3>
          </div>
        )}
      </main>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: var(--contentMinHeight);
  background-color: var(--primaryBgcolor);
`;
